// Generated by purs version 0.15.15
import * as $foreign from "./foreign.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Effect_Console from "../Effect.Console/index.js";
import * as Restaumatic_Locales from "../Restaumatic.Locales/index.js";
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showString);
var show1 = /* #__PURE__ */ Data_Show.show(Restaumatic_Locales.showLocale);
var defaultLocale = /* #__PURE__ */ (function () {
    return Restaumatic_Locales.PL.value;
})();
var getGlobalLocale = function __do() {
    var str = $foreign["_getGlobalLocale"]();
    var v = Restaumatic_Locales.fromText(str);
    if (v instanceof Data_Maybe.Nothing) {
        Effect_Console.log("WARNING: Invalid global locale: " + (show(str) + (". Defaulting to " + show1(defaultLocale))))();
        return defaultLocale;
    };
    if (v instanceof Data_Maybe.Just) {
        return v.value0;
    };
    throw new Error("Failed pattern match at Restaumatic.I18nWrapper (line 20, column 3 - line 25, column 18): " + [ v.constructor.name ]);
};
export {
    getGlobalLocale
};
